import { MixpanelClient, initializeMixpanel } from '@40seas/frontend/libs/providers';

export class EventTracker {
    private static _instance: EventTracker;

    readonly mixpanelClient: MixpanelClient;

    private constructor() {
        this.mixpanelClient = initializeMixpanel();
    }

    static get Instance(): EventTracker {
        if (!EventTracker._instance) {
            EventTracker._instance = new EventTracker();
        }

        return EventTracker._instance;
    }

    setUser(props: { email: string; name: string }) {
        this.mixpanelClient.identify(props.email);

        this.mixpanelClient.people.set({
            $email: props.email,
            $name: props.name,
        });
    }
}
